import React, { forwardRef, useContext } from 'react';
import { PopoverContext, PopoverProvider } from './PopoverProvider';
import { Menu, MenuTrigger } from './Menu';
import { MenuProvider } from './MenuProvider';
import { Popover } from '../Popover/Popover';
const PopoverInner = forwardRef(({ children, testId, setIsOpen, ...rest }, ref) => {
    const { popoverProps } = useContext(PopoverContext);
    return popoverProps ? (React.createElement(Popover, { ...popoverProps, ...rest, onClose: (isOpen) => {
            popoverProps.onClose?.(isOpen);
            setIsOpen?.(isOpen);
        }, testId: testId, ref: ref }, children)) : null;
});
PopoverInner.displayName = 'PopoverInner';
export const PopoverMenu = forwardRef(({ placement = 'top', hasArrow = true, testId, width, height, offset, isOpen, setIsOpen, children, id, ...rest }, ref) => {
    const menuElement = Array.isArray(children) && children.find((child) => child.type === Menu);
    const menuTriggerElement = Array.isArray(children) && children.find((child) => child.type === MenuTrigger);
    return (React.createElement(PopoverProvider, { placement: placement, hasArrow: hasArrow, width: width, height: height, offset: offset, isOpen: isOpen, id: id, setIsOpen: setIsOpen },
        React.createElement(MenuProvider, null,
            React.createElement(PopoverInner, { ...rest, testId: testId, setIsOpen: setIsOpen, ref: ref }, menuElement ?? 'No menu found'),
            menuTriggerElement ?? 'No menu trigger found')));
});
PopoverMenu.displayName = 'PopoverMenu';
